const focusItems = [
  {
    title: '咒术回战：涩谷事变篇',
    desc: '五条悟被封印，宿傩肆虐涩谷，咒术界史上最大规模战斗全面爆发。',
    tag: '热门焦点',
    image: 'https://readdy.ai/api/search-image?query=Intense%20urban%20fantasy%20battle%20anime%20scene%20in%20Shibuya%20at%20night%2C%20dramatic%20orange%20and%20crimson%20energy%20effects%2C%2C%20chaotic%20urban%20destruction%20aesthetic%2C%20epic%20scale%20composition%2C%20warm%20dramatic%20lighting&width=800&height=500&seq=51anime-carousel-01&orientation=landscape',
  },
  {
    title: '葬送的芙莉莲：理解人心',
    desc: '漫长寿命的精灵魔法使，在旅途中重新理解与人类的羁绊与告别。',
    tag: '口碑佳作',
    image: 'https://readdy.ai/api/search-image?query=Melancholic%20fantasy%20anime%20scene%20with%20elf%20character%20gazing%20at%20starry%20night%20sky%2C%20nostalgic%20atmosphere%2C%20soft%20amber%20and%20cream%20moonlight%2C%20gentle%20breeze%20through%20grass%2C%20emotional%20storytelling%20visual%2C%20clean%20composition&width=800&height=500&seq=51anime-carousel-02&orientation=landscape',
  },
  {
    title: '鬼灭之刃：无限城决战',
    desc: '炭治郎与众柱集结，在无限城中展开与无惨的最终殊死决战。',
    tag: '即将上映',
    image: 'https://readdy.ai/api/search-image?query=Epic%20demon%20slayer%20anime%20scene%20with%20warriors%20gathering%20in%20mysterious%20castle%2C%20dramatic%20moonlight%20and%20flame%20visuals%2C%20traditional%20Japanese%20architecture%2C%20intense%20pre-battle%20atmosphere%2C%20warm%20golden%20and%20crimson%20lighting&width=800&height=500&seq=51anime-carousel-03&orientation=landscape',
  },
  {
    title: '斗破苍穹：中州风云',
    desc: '萧炎踏入中州大陆，各方势力云集，强者之路再启新篇章。',
    tag: '国漫之光',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20donghua%20scene%20with%20martial%20hero%20standing%20atop%20mountain%20peak%2C%20vast%20ancient%20Chinese%20landscape%20below%2C%20flowing%20energy%20and%20robes%2C%20dramatic%20golden%20sunset%20lighting%2C%20epic%20cultivation%20atmosphere&width=800&height=500&seq=51anime-carousel-04&orientation=landscape',
  },
  {
    title: '我推的孩子：舞台剧篇',
    desc: '星野爱久爱海（阿库亚）深入演艺圈，舞台剧改编背后暗藏杀机。',
    tag: '话题热议',
    image: 'https://readdy.ai/api/search-image?query=Theatrical%20anime%20scene%20with%20stage%20performance%20and%20spotlight%2C%20dramatic%20contrast%20between%20bright%20stage%20and%20dark%20audience%2C%20showbiz%20atmosphere%2C%20warm%20golden%20and%20amber%20lighting%2C%20suspenseful%20composition&width=800&height=500&seq=51anime-carousel-05&orientation=landscape',
  },
  {
    title: '海贼王：艾尔巴夫篇',
    desc: '路飞抵达巨人族故乡艾尔巴夫，传说中的太阳神之谜即将解开。',
    tag: '经典连载',
    image: 'https://readdy.ai/api/search-image?query=Epic%20pirate%20adventure%20anime%20scene%20with%20giant%20viking-inspired%20warriors%20and%20vast%20mythical%20landscape%2C%20grand%20scale%20world-building%20visual%2C%20warm%20golden%20sunlight%2C%20adventurous%20spirit%2C%20clean%20composition&width=800&height=500&seq=51anime-carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            当前最受关注的动漫专题内容，深度解读每一部热门作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {focusItems.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              className="group block bg-background-100 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="aspect-[8/5] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full font-medium mb-2">{item.tag}</span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}